import React, { useState, useEffect, useRef } from 'react'
import Zemelapis from '../components/Zemelapis'
import ZenkliukoIkona from '../components/ZenkliukoIkona'
import PrisiminimuGalerija from './PrisiminimuGalerija'
import CoachMark from '../components/CoachMark'
import { arMatyta, pazymetiMatyta } from '../utils/onboarding'
import { getAplankytos } from '../utils/aplankytos'
import { getPrisiminimai, grupuotiPrisiminimai } from '../utils/prisiminimai'
import { gautiPrisiminimoNuotrauka } from '../utils/nuotrauku_saugykla'
import { skaiciuotiStatus, getZenkliukai, skaiciuotiTaskus, skaiciuotiLygi, archetipas } from '../utils/statai'

const KAT_LABEL = { gamta: 'Gamta', jura: 'Jūra', istorija: 'Istorija', miestas: 'Miestas' }

function Uzraktas() {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6, color: '#7A8A7E', fontSize: 11, marginBottom: 14 }}>
      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.85"><rect x="3" y="11" width="18" height="11" rx="2" /><path d="M7 11V7a5 5 0 0 1 10 0v4" /></svg>
      matoma tik tau
    </div>
  )
}

function Statas({ skaicius, priedas, etikete }) {
  return (
    <div style={{ background: '#1E2E27', borderRadius: 12, padding: '12px 14px' }}>
      <div style={{ color: '#F0E8D5', fontFamily: "'Lora', Georgia, serif", fontSize: 22 }}>{skaicius}{priedas && <span style={{ fontSize: 12, color: '#7A8A7E' }}> {priedas}</span>}</div>
      <div style={{ color: '#7A8A7E', fontSize: 11, marginTop: 2 }}>{etikete}</div>
    </div>
  )
}

function Rekordas({ ikona, etikete, reiksme }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '13px 16px', borderBottom: '1px solid #2A3B32' }}>
      <ZenkliukoIkona ikona={ikona} dydis={17} />
      <span style={{ color: '#B0B8A8', fontSize: 13, flex: 1 }}>{etikete}</span>
      <span style={{ color: '#F0E8D5', fontSize: 14, fontWeight: 500 }}>{reiksme}</span>
    </div>
  )
}

function Profilis({ atidaryta, onClose, visosVietos, onZenkliukai }) {
  const [tab, setTab] = useState('zemelapis')
  const [aplankytos, setAplankytos] = useState([])
  const [prisiminimai, setPrisiminimai] = useState([])
  const [zemRezimas, setZemRezimas] = useState('vietos') // 'vietos' | 'nuotraukos'
  const [prisiminimuTaskai, setPrisiminimuTaskai] = useState([]) // su nuotraukų dataUrl
  const [galerijaGrupe, setGalerijaGrupe] = useState(null)
  const zenklRef = useRef(null)
  const [coachRodyti, setCoachRodyti] = useState(false)

  useEffect(() => {
    if (atidaryta) {
      setAplankytos(getAplankytos())
      setPrisiminimai(getPrisiminimai())
      setTab('zemelapis')
      setZemRezimas('vietos')
      if (!arMatyta('ob_zenkliukai')) {
        const t = setTimeout(() => setCoachRodyti(true), 480)
        return () => clearTimeout(t)
      }
    } else {
      setCoachRodyti(false)
    }
  }, [atidaryta])

  // Užkraunam prisiminimų grupių miniatiūras (naujausią nuotrauką grupei)
  useEffect(() => {
    if (!atidaryta || tab !== 'zemelapis' || zemRezimas !== 'nuotraukos') return
    let gyvas = true
    const grupes = grupuotiPrisiminimai()
    Promise.all(grupes.map(async g => ({
      raktas: g.raktas, lat: g.lat, lng: g.lng, count: g.count, pavadinimas: g.pavadinimas,
      elementai: g.elementai,
      dataUrl: await gautiPrisiminimoNuotrauka(g.naujausias.id),
    }))).then(rez => { if (gyvas) setPrisiminimuTaskai(rez.filter(r => r.dataUrl)) })
    return () => { gyvas = false }
  }, [atidaryta, tab, zemRezimas, prisiminimai])

  const statai = skaiciuotiStatus(aplankytos, visosVietos, prisiminimai)
  const zenkliukai = getZenkliukai(statai)
  const uzdirbti = zenkliukai.filter(z => z.uzdirbtas)
  const taskai = skaiciuotiTaskus(statai, uzdirbti.length)
  const lygis = skaiciuotiLygi(taskai)
  const portretas = archetipas(statai)
  const prisegti = uzdirbti.slice(0, 3)
  const aplankytiIds = new Set(aplankytos.map(v => v.id))

  return (
    <div style={{ position: 'fixed', inset: 0, background: '#141F1A', zIndex: 1001, transform: atidaryta ? 'translateX(0)' : 'translateX(100%)', transition: 'transform 340ms cubic-bezier(0.32,0.72,0,1)', display: 'flex', flexDirection: 'column' }}>

      {/* Viršus */}
      <div style={{ flexShrink: 0 }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: 'calc(14px + env(safe-area-inset-top)) 16px 6px' }}>
          <button onClick={onClose} aria-label="Atgal" style={{ width: 34, height: 34, borderRadius: '50%', border: '1px solid #3A4C42', background: 'transparent', color: '#F0E8D5', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.85" strokeLinecap="round" strokeLinejoin="round"><path d="M15 18l-6-6 6-6" /></svg>
          </button>
          <span style={{ color: '#7A8A7E', fontSize: 12, letterSpacing: '0.08em' }}>MANO PROFILIS</span>
          <div style={{ width: 34 }} />
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: 14, padding: '6px 18px 18px' }}>
          <div style={{ width: 62, height: 62, borderRadius: '50%', background: 'rgba(229,168,64,0.14)', border: '2px solid #E5A840', color: '#E5A840', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: "'Lora', Georgia, serif", fontSize: 24, flexShrink: 0 }}>I</div>
          <div style={{ flexShrink: 0 }}>
            <div style={{ color: '#F0E8D5', fontSize: 22, fontWeight: 500, fontFamily: "'Lora', Georgia, serif", letterSpacing: '-0.01em', lineHeight: 1.1 }}>Ignas</div>
            <div style={{ color: '#E5A840', fontSize: 12, fontWeight: 500, marginTop: 4 }}>Lygis {lygis.lygis}</div>
          </div>
          <div style={{ flex: 1, display: 'flex', justifyContent: 'center', gap: 24 }}>
            <div style={{ textAlign: 'center' }}>
              <div style={{ color: '#F0E8D5', fontSize: 19, fontWeight: 500 }}>0</div>
              <div style={{ color: '#7A8A7E', fontSize: 12, marginTop: 3 }}>sekėjai</div>
            </div>
            <div style={{ textAlign: 'center' }}>
              <div style={{ color: '#F0E8D5', fontSize: 19, fontWeight: 500 }}>0</div>
              <div style={{ color: '#7A8A7E', fontSize: 12, marginTop: 3 }}>sekama</div>
            </div>
          </div>
        </div>

        {/* Prisegti ženkliukai */}
        <div ref={zenklRef} style={{ padding: '0 16px 14px' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
            <span style={{ color: '#7A8A7E', fontSize: 10, letterSpacing: '0.1em' }}>PRISEGTI ŽENKLIUKAI</span>
            <span onClick={onZenkliukai} style={{ color: '#E5A840', fontSize: 11, fontWeight: 500, cursor: 'pointer' }}>Visi ({uzdirbti.length}) ›</span>
          </div>
          {prisegti.length > 0 ? (
            <div style={{ display: 'flex', gap: 16 }}>
              {prisegti.map(z => (
                <div key={z.id} style={{ textAlign: 'center' }}>
                  <div style={{ width: 56, height: 56, borderRadius: '50%', background: 'rgba(229,168,64,0.16)', border: '2px solid #E5A840', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <ZenkliukoIkona ikona={z.ikona} dydis={26} />
                  </div>
                  <div style={{ color: '#B0B8A8', fontSize: 9, marginTop: 5, width: 60, lineHeight: 1.2 }}>{z.pavadinimas}</div>
                </div>
              ))}
            </div>
          ) : (
            <p style={{ color: '#7A8A7E', fontSize: 12, margin: 0 }}>Dar nėra — keliauk ir žymėk „Buvau čia", kad uždirbtum pirmą.</p>
          )}
        </div>

        {/* Tabs */}
        <div style={{ display: 'flex', padding: '0 18px', borderBottom: '1px solid #2A3B32' }}>
          {[['zemelapis', 'Žemėlapis'], ['statistika', 'Statistika'], ['apie', 'Apie tave']].map(([id, label]) => (
            <div key={id} onClick={() => setTab(id)} style={{ flex: 1, textAlign: 'center', paddingBottom: 8, fontSize: 13, cursor: 'pointer', color: tab === id ? '#F0E8D5' : '#7A8A7E', borderBottom: `2px solid ${tab === id ? '#E5A840' : 'transparent'}` }}>{label}</div>
          ))}
        </div>
      </div>

      {/* Turinys */}
      <div style={{ flex: 1, overflowY: 'auto', padding: 16 }}>
        {tab === 'zemelapis' && (
          <div>
            <Uzraktas />

            {/* Perjungiklis: Vietos / Nuotraukos */}
            <div style={{ display: 'flex', gap: 4, background: '#1E2E27', border: '1px solid #2A3B32', borderRadius: 10, padding: 3, marginBottom: 12 }}>
              {[['vietos', 'Vietos'], ['nuotraukos', 'Nuotraukos']].map(([id, label]) => (
                <button
                  key={id}
                  onClick={() => setZemRezimas(id)}
                  style={{ flex: 1, padding: '8px 0', borderRadius: 7, border: 'none', cursor: 'pointer', fontSize: 12, fontWeight: 500, fontFamily: 'Syne, system-ui, sans-serif', background: zemRezimas === id ? 'rgba(229,168,64,0.16)' : 'transparent', color: zemRezimas === id ? '#E5A840' : '#7A8A7E', transition: 'all 0.15s ease' }}
                >
                  {label}
                </button>
              ))}
            </div>

            <div style={{ height: 320, borderRadius: 14, overflow: 'hidden', border: '1px solid #2A3B32', marginBottom: 12 }}>
              {zemRezimas === 'vietos' ? (
                <Zemelapis
                  vietos={visosVietos}
                  lokacija={null}
                  onVietaPasirinkta={() => {}}
                  pasirinkta={null}
                  aktyviosKategorijos={[]}
                  aplankytiIds={aplankytiIds}
                  fitRibos={visosVietos && visosVietos.length ? visosVietos : null}
                />
              ) : prisiminimuTaskai.length > 0 ? (
                <Zemelapis
                  vietos={[]}
                  lokacija={null}
                  onVietaPasirinkta={() => {}}
                  pasirinkta={null}
                  aktyviosKategorijos={[]}
                  prisiminimuTaskai={prisiminimuTaskai}
                  onPrisiminimas={(g) => setGalerijaGrupe(g)}
                  fitRibos={prisiminimuTaskai.map(g => ({ latitude: g.lat, longitude: g.lng }))}
                />
              ) : (
                <div style={{ height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 10, padding: 24, textAlign: 'center', background: '#1E2E27' }}>
                  <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="#3A4C42" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z" /><circle cx="12" cy="13" r="4" /></svg>
                  <p style={{ color: '#7A8A7E', fontSize: 12.5, margin: 0, lineHeight: 1.5 }}>Dar nėra prisiminimų.<br />Žymėk „Buvau čia" su nuotrauka — jos atsiras čia, kur nufotkinai.</p>
                </div>
              )}
            </div>

            <div style={{ textAlign: 'center', color: '#B0B8A8', fontSize: 13 }}>
              {zemRezimas === 'vietos' ? (
                <><span style={{ color: '#E5A840', fontWeight: 500 }}>{statai.procIstirta}%</span> Lietuvos ištirta · {statai.vietos}/{statai.visoVietu} vietų</>
              ) : (
                <><span style={{ color: '#E5A840', fontWeight: 500 }}>{prisiminimai.length}</span> {prisiminimai.length === 1 ? 'prisiminimas' : (prisiminimai.length % 10 === 0 || (prisiminimai.length % 100 >= 11 && prisiminimai.length % 100 <= 19)) ? 'prisiminimų' : 'prisiminimai'}</>
              )}
            </div>
          </div>
        )}

        {tab === 'statistika' && (
          <div>
            <Uzraktas />
            <div style={{ color: '#7A8A7E', fontSize: 10, letterSpacing: '0.1em', marginBottom: 8 }}>VISO</div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginBottom: 16 }}>
              <Statas skaicius={statai.vietos} etikete="vietų aplankyta" />
              <Statas skaicius={statai.km.toLocaleString('lt-LT')} priedas="km" etikete="nukeliauta" />
              <Statas skaicius={statai.regionai} etikete="regionų" />
              <Statas skaicius={statai.nuotraukos} etikete="prisiminimų" />
            </div>

            <div style={{ color: '#7A8A7E', fontSize: 10, letterSpacing: '0.1em', marginBottom: 8 }}>REKORDAI</div>
            <div style={{ background: '#1E2E27', border: '1px solid #2A3B32', borderRadius: 14, overflow: 'hidden', marginBottom: 16 }}>
              <Rekordas ikona="route" etikete="Tolimiausia kelionė" reiksme={statai.tolimiausia ? `${statai.tolimiausia} km` : '—'} />
              <Rekordas ikona="star" etikete="Daugiausia per dieną" reiksme={statai.daugiausiaPerDiena ? `${statai.daugiausiaPerDiena} ${statai.daugiausiaPerDiena === 1 ? 'vieta' : 'vietos'}` : '—'} />
            </div>

            <div style={{ color: '#7A8A7E', fontSize: 10, letterSpacing: '0.1em', marginBottom: 10 }}>APLANKYTA · {statai.vietos}/{statai.visoVietu}</div>
            <div style={{ background: '#1E2E27', border: '1px solid #2A3B32', borderRadius: 14, padding: '14px 16px' }}>
              {['gamta', 'jura', 'istorija', 'miestas'].map(k => {
                const d = statai.pagalKategorija[k]
                const proc = d.viso ? Math.round((d.aplankyta / d.viso) * 100) : 0
                return (
                  <div key={k} style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: k === 'miestas' ? 0 : 10 }}>
                    <span style={{ color: '#B0B8A8', fontSize: 12, width: 60 }}>{KAT_LABEL[k]}</span>
                    <div style={{ flex: 1, height: 5, background: '#2A3B32', borderRadius: 3, overflow: 'hidden' }}><div style={{ width: `${proc}%`, height: '100%', background: '#E5A840' }} /></div>
                    <span style={{ color: '#7A8A7E', fontSize: 11, width: 46, textAlign: 'right' }}>{d.aplankyta}/{d.viso}</span>
                  </div>
                )
              })}
            </div>
          </div>
        )}

        {tab === 'apie' && (
          <div>
            <Uzraktas />
            {portretas ? (
              <>
                <div style={{ textAlign: 'center' }}>
                  <div style={{ width: 64, height: 64, borderRadius: '50%', background: 'rgba(229,168,64,0.14)', border: '2px solid #E5A840', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 12px' }}>
                    <ZenkliukoIkona ikona={portretas.ikona} dydis={30} />
                  </div>
                  <div style={{ color: '#7A8A7E', fontSize: 10, letterSpacing: '0.1em', marginBottom: 6 }}>TAVO KELIAUTOJO TIPAS</div>
                  <div style={{ fontFamily: "'Lora', Georgia, serif", color: '#F0E8D5', fontSize: 24, fontWeight: 500 }}>{portretas.tipas}</div>
                </div>
                <p style={{ color: '#B0B8A8', fontSize: 13.5, lineHeight: 1.6, textAlign: 'center', margin: '12px 4px 16px' }}>{portretas.aprasymas}</p>
                <div style={{ background: '#1E2E27', border: '1px solid #2A3B32', borderRadius: 14, overflow: 'hidden' }}>
                  <Rekordas ikona="route" etikete="Vidutinis ruožas" reiksme={statai.vidutinisKm ? `${statai.vidutinisKm} km` : '—'} />
                  <Rekordas ikona="leaf" etikete="Mėgstama kategorija" reiksme={statai.megstama ? `${KAT_LABEL[statai.megstama]} · ${statai.megstamaProc}%` : '—'} />
                  <div style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '13px 16px' }}>
                    <ZenkliukoIkona ikona="star" dydis={17} />
                    <span style={{ color: '#B0B8A8', fontSize: 13, flex: 1 }}>Dažniausia diena</span>
                    <span style={{ color: '#F0E8D5', fontSize: 14, fontWeight: 500 }}>{statai.dazniausiaDiena || '—'}</span>
                  </div>
                </div>
              </>
            ) : (
              <p style={{ color: '#7A8A7E', fontSize: 13, textAlign: 'center', padding: '40px 24px', lineHeight: 1.6 }}>
                Aplankyk bent kelias vietas (žymėk „Buvau čia"), ir čia atsiras tavo keliautojo portretas — sudarytas pagal tavo keliones.
              </p>
            )}
          </div>
        )}
      </div>

      {galerijaGrupe && (
        <PrisiminimuGalerija grupe={galerijaGrupe} onClose={() => setGalerijaGrupe(null)} />
      )}

      {coachRodyti && !galerijaGrupe && (
        <CoachMark
          targetRef={zenklRef}
          antraste="Ženkliukai ir lygiai"
          tekstas={'Paspausk „Visi", kad pamatytum visus ženkliukus, kuriuos gali gauti. Uždirbtus prisegsi čia — tavo Lietuva augs.'}
          paskutinis
          onKitas={() => { pazymetiMatyta('ob_zenkliukai'); setCoachRodyti(false) }}
        />
      )}
    </div>
  )
}

export default Profilis
